import { yoyoHttp } from '../../services/http.service';
import { MUTATIONS, ACTIONS, CORE_PREFIX, CREATE_SHIPMENT_PREFIX, GETTERS } from '../constants';
import { allBookingSystems } from '../../data/headerData.js';
import { EventBus } from '../../services/event-bus.js';
import { EVENTS, BOOKING_TYPES } from '../../store/nameConstants';
import { authService } from '../../msal';

const technicalError = {
    key: 'TECHNICALERROR',
    message: 'Technical Error Contact Link Support.',
    localizedMessage: 'Technical Error Contact Link Support.'
};

const actions = {
    async [ACTIONS.CREATESHIPMENT.GET_SHIPMENT_PRICE](ctx, data) {
        let selectedProduct = data.selectedProduct;
        let selectedService = selectedProduct.selectedService;
        if (ctx.rootState.core.shipmentSystem == 'YOYONorway' && selectedService.price && selectedService.price > 0) {
            let priceLines = selectedProduct.priceLines;
            priceLines.push({ value: selectedService.price, text: selectedService.productService })
            return priceLines;
        }

        let request = {
            shipment: ctx.getters.shipmentForBackend,
            selectedProduct: data.selectedProduct
        };
        let response = await yoyoHttp.post('/api/Shipment/GetShipmentPrice', request)
        if (response.status == 200) {
            return response.data;
        }
        return [];
    },

    async [ACTIONS.CREATESHIPMENT.SET_ISCOLLIDEMENSIONS](ctx, data) {
        ctx.commit(MUTATIONS.CREATESHIPMENT.SET_ISCOLLIDEMENSIONS, data);
    },

    async [ACTIONS.CREATESHIPMENT.SET_SERVICE_PRICES](ctx, data) {
        ctx.commit(MUTATIONS.CREATESHIPMENT.SET_SERVICE_PRICES, data);
    },

    async [ACTIONS.CREATESHIPMENT.SET_ISDANGEROUSGOODS](ctx, data) {
        ctx.commit(MUTATIONS.CREATESHIPMENT.SET_ISDANGEROUSGOODS, data);
    },

    async [ACTIONS.CREATESHIPMENT.SET_BACKENDERROR](ctx, data) {
        ctx.commit(MUTATIONS.CREATESHIPMENT.SET_BACKENDERROR, data);
    },

    async [ACTIONS.CREATESHIPMENT.CLEAR_BACKENDERRORS](ctx) {
        ctx.commit(MUTATIONS.CREATESHIPMENT.CLEAR_BACKENDERRORS);
    },

    async [ACTIONS.CREATESHIPMENT.DELETE_ADDRESS](ctx, addressId) {
        const r = await yoyoHttp.delete('api/AddressBook/DeleteAddress', {
            params: {
                addressId: addressId
            }
        });
    },

    async [ACTIONS.CREATESHIPMENT.UPDATE_ADDRESS](ctx, address) {
        address.companyId = ctx.state.selectedCompanyId;

        const r = await yoyoHttp.post('api/AddressBook/UpdateAddress/', address);

        if (r.status === 200) {
            ctx.dispatch(ACTIONS.CREATESHIPMENT.FETCH_ADDRESS_BOOK);
        }
    },

    async [ACTIONS.CREATESHIPMENT.CREATE_ADDRESS](ctx, address) {
        address.companyId = ctx.state.selectedCompanyId;

        const r = await yoyoHttp.post('/api/AddressBook/CreateAddress', address);

        if (r.status === 200) {
            ctx.dispatch(ACTIONS.CREATESHIPMENT.FETCH_ADDRESS_BOOK);
        }
    },

    async [ACTIONS.CREATESHIPMENT.FETCH_ADDRESS_BOOK](ctx, companyId) {
        const targetCompanyId = companyId || ctx.state.selectedCompanyId;
        const r = await yoyoHttp.get('/api/AddressBook/GetAddressBook', {
            params: {
                companyId: targetCompanyId
            }
        });

        if (r.status === 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_ADDRESS_BOOK, r.data);
        }
    },


    async [ACTIONS.CREATESHIPMENT.FETCH_DEFAULT_VALUES](ctx) {
        const r = await yoyoHttp.cachedGet('api/Shipment/GetDefaultValues', {
            params: {
                accountId: ctx.rootState.core.companyAccountId,
                companyId: ctx.state.selectedCompanyId
            }
        });

        if (r.status === 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_DEFAULT_VALUES, r.data);
            EventBus.$emit(EVENTS.SET_DEFAULT_VALUES, r.data);
        }
    },

    async [ACTIONS.CREATESHIPMENT.FETCH_BOOKING_OPTIONS]({
        commit,
        getters,
        dispatch,
        state,
        rootState
    }) {
        const r = await yoyoHttp.get('api/Shipment/GetViewOptions', {
            params: {
                accountId: rootState.core.companyAccountId,
                companyId: state.selectedCompanyId
            }
        });

        if (r.status === 200) {
            commit(MUTATIONS.CREATESHIPMENT.SET_BOOKING_OPTIONS, r.data);
            if (getters[GETTERS.CREATE_SHIPMENT.SHIPMENTPACKAGING_ACTIVE]) {
                dispatch(ACTIONS.CREATESHIPMENT.FETCH_SHIPMENTPACKAGING);
            }
            //commit(MUTATIONS.CREATESHIPMENT.SET_INSURANCEAMOUNT_REQUIRED, r.data);
            dispatch(ACTIONS.CREATESHIPMENT.FETCH_ADDRESS_BOOK);
            dispatch(ACTIONS.CREATESHIPMENT.FETCH_CUSTOMER_DESCRIPTIONS);
            dispatch(ACTIONS.CREATESHIPMENT.FETCH_DANGEROUS_GOODS_TYPES);
            dispatch(ACTIONS.CREATESHIPMENT.FETCH_DANGEROUS_GOODS_DESCRIPTIONS);
            dispatch(ACTIONS.CREATESHIPMENT.FETCH_PACKAGING_TYPES);

            //dispatch(ACTIONS.CREATESHIPMENT.FETCH_TRANSPORT_PRODUCTS);
        }
    },

    async [ACTIONS.CREATESHIPMENT.FETCH_SHIPMENTPACKAGING](ctx) {
        const r = await yoyoHttp.get('/api/StaticData/GetCustomerProducts', {
            params: {
                companyId: ctx.rootState.createShipment.selectedCompanyId
            }
        });
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_SHIPMENTPACKAGING, r.data);
        } else {
            console.error(r);
        }
    },
    async [ACTIONS.CREATESHIPMENT.FETCH_CUSTOMER_DESCRIPTIONS](ctx) {
        const r = await yoyoHttp.cachedGet('/api/StaticData/GetCustomerDescriptions', {
            params: {
                companyId: ctx.rootState.createShipment.selectedCompanyId
            }
        });
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_CUSTOMER_DESCRIPTIONS, r.data);
        } else {
            console.error(r);
        }
    },

    async [ACTIONS.CREATESHIPMENT.FETCH_REFERENCE_TYPES](ctx) {
        const r = await yoyoHttp.cachedGet('/api/StaticData/GetReferenceTypes', null);

        if (r.status === 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_REFERENCE_TYPES, r.data);
        } else {
            console.error(r);
        }
    },

    async [ACTIONS.CREATESHIPMENT.FETCH_COMPANY_ACCOUNT_ADDRESSES](ctx) {
        const r = await yoyoHttp.cachedGet('/api/User/GetCompanyAccountAddress', {
            params: {
                accountId: ctx.rootState.core.companyAccountId
            }
        });

        if (r.status === 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_COMPANY_ACCOUNT_ADDRESSES, r.data);
        }
    },

    async [ACTIONS.CREATESHIPMENT.FETCH_SHIPPING_OPTIONS](ctx, shipment) {
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, true, { root: true });
        ctx.commit(MUTATIONS.CREATESHIPMENT.SET_SHIPMENT, shipment);
       
        const request = {
            shipment: ctx.getters.shipmentForBackend,
            transactionDetail: { customerTransactionId: ctx.rootState.core.customerTransactionId },
            auth0UserId: authService.getUserId()
        };
        
        //if incoterm are not selected by customer, it'll set to DAP!
        if(request.shipment.shipmentOptions.incoterms == null || request.shipment.shipmentOptions.incoterms == '' ){
            request.shipment.shipmentOptions.incoterms = 'DAP'
        }

        const r = await yoyoHttp.post('/api/Shipment/GetShippingOptions', request);
        let error = technicalError;
        if (r.status === 200) {
            ctx.dispatch('fetchTransitTimes', { request: request, response: r.data })
            ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, false, { root: true });
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_SHIPPING_OPTIONS, r.data);
            return;
        } else if (r.status === 400) {
            console.error('/api/Shipment/GetShippingOptions', r);
            let msg = '';
            for (const prop in r.data) {
                r.data[prop].forEach((el) => {
                    msg += el + ' ';
                });
            }
            error = {
                key: 'VALIDATION',
                message: msg,
                localizedMessage: msg
            };
        }
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, false, { root: true });
        ctx.commit(MUTATIONS.CREATESHIPMENT.SET_BACKENDERROR_TECHNICAL, error);
    },

    async fetchTransitTimes(ctx, data) {
        const r = await yoyoHttp.post('/api/Shipment/TransitTimes', data);
        if (r.status == 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_TRANSITTIMES, r.data);
        }
        else {
            console.error('TransitTime Error', r);
        }
    },

    async [ACTIONS.CREATESHIPMENT.SET_PRICE_EXPANDED](ctx, data) {
        ctx.commit(MUTATIONS.CREATESHIPMENT.SET_PRICE_EXPANDED, data);
    },

    async [ACTIONS.CREATESHIPMENT.FETCH_DANGEROUS_GOODS_TYPES](ctx) {
        const r = await yoyoHttp.cachedGet('api/StaticData/GetDangerousGoodsType', null);
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_DANGEROUS_GOODS_TYPES, r.data);
        }
    },
    async [ACTIONS.CREATESHIPMENT.FETCH_DANGEROUS_GOODS_DESCRIPTIONS](ctx) {
        const r = await yoyoHttp.cachedGet('api/StaticData/GetDangerousGoodsDescriptions', null);
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_DANGEROUS_GOODS_DESCRIPTIONS, r.data);
        }
    },

    async [ACTIONS.CREATESHIPMENT.FETCH_PACKAGING_TYPES](ctx) {
        const r = await yoyoHttp.cachedGet('api/StaticData/GetPackagingTypes', {
            params: {
                companyId: ctx.state.selectedCompanyId
            }
        });

        if (r.status === 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_PACKAGING_TYPES, r.data);
        }
    },

    async [ACTIONS.CREATESHIPMENT.GETSHIPMENTDATA](ctx, shipmentId) {
        let response = await yoyoHttp.get('/api/Shipment/GetShipmentData', {
            params: {
                id: shipmentId
            }
        });
        return response.data;
    },

    async [ACTIONS.CREATESHIPMENT.GETSHIPMENTDATABYLINKID](ctx, linkId) {
        let response = await yoyoHttp.get('/api/Shipment/GetShipmentDataByLinkId', {
            params: {
                linkId: linkId
            }
        });
        return response.data;
    },
    async [ACTIONS.HISTORY.GET_INVOICE_DATA](ctx, shipmentId: number) {
        const response = await yoyoHttp.get('/api/Shipment/GetInvoiceData', {
            params: { id: shipmentId }
        });

        if (response.status === 200 && response.data) {
            return response.data;
        }

        return null;
    },

    async [ACTIONS.CREATESHIPMENT.GETSHOTFILESHIPMENTDATA](ctx, shipmentId) {
        let response = await yoyoHttp.get('/api/Shipment/GetShipmentData', {
            params: {
                id: shipmentId,
                isShortFileShipment: true
            }
        });
        return response.data;
    },

    async [ACTIONS.CREATESHIPMENT.CREATE_SHIPMENT](ctx, payload) {
        ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, true, { root: true });
        ctx.commit(MUTATIONS.CREATESHIPMENT.SET_SHIPMENT, payload.shipment);
        let request: any = {
            shipment: ctx.getters.shipmentForBackend,
            transactionDetail: { customerTransactionId: ctx.rootState.core.customerTransactionId },
            selectedProduct: payload.selectedProduct,
            saveFlags: payload.saveFlags,
            auth0UserId: authService.getUserId(),
            files: payload.files,
            invoice: payload.invoice
        };
        
        if (request.shipment.linkedShipmentLinkId !== undefined) {
            request.linkedShipmentLinkId = request.shipment.linkedShipmentLinkId;
        }
        
        if (request.shipment.action != undefined) {
            request.action = request.shipment.action;
        }
        
        if (payload.awb !== undefined) {
            request.originalAWB = payload.awb;
            request.shipment.action = "RegisterSaveShipment";
        }

        if (request.shipment.shipmentOptions.incoterms == null || request.shipment.shipmentOptions.incoterms == '') {
            //Set incoterms default to DAP if not set
            request.shipment.shipmentOptions.incoterms = 'DAP';
        }

        let response;
        if (payload.shipment.bookingType === BOOKING_TYPES.ERROR_BOOKING) {
            request.errorMessage = payload.errorMessage;
            response = await yoyoHttp.post('/api/Shipment/CreateErrorBooking', request);
        } else if (payload.shipmentId && !payload.copy) {
            response = await yoyoHttp.post(
                '/api/Shipment/OverrideShipment/' + payload.shipmentId,
                request
            );
        } else {
            response = await yoyoHttp.post('/api/Shipment/CreateShipment', request);
        }

        let error = technicalError;

        if (response.data.isAES && !response.data.success) {
            return response;
        }

        if (response.status === 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.SHIPMENT_CREATED, response.data);

            ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_SHIPMENT_ID, response.data.shipmentId, {
                root: true
            });
            ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LINK_ID, response.data.linkId, {
                root: true
            });
            await ctx.dispatch('reloadSavedAdressesOrDescription', request);

            if (payload.shipment.bookingType === BOOKING_TYPES.PRE_BOOKING) {
                ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, false, { root: true });
            }
        } else {
            console.error('/api/Shipment/CreateShipment', response);
            ctx.commit(CORE_PREFIX + MUTATIONS.CORE.SET_LOADING, false, { root: true });
            if (response.status == 400) {
                let msg = '';
                for (const prop in response.data) {
                    response.data[prop].forEach((el) => {
                        msg += el + ' ';
                    });
                }
                error = {
                    key: 'VALIDATION',
                    message: msg,
                    localizedMessage: msg
                };
            }
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_BACKENDERROR_TECHNICAL, error);
        }
    },

    async [ACTIONS.CREATESHIPMENT.UPSERT_SHIPMENTPACKAGING](ctx, payload) {
        payload.auth0UserId = authService.getUserId();
        const r = await yoyoHttp.post('/api/ShipmentPackaging/UpsertShipmentPackaging', payload);
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.UPSERT_SHIPMENTPACKAGING, r.data);
        }
    },

    async [ACTIONS.CREATESHIPMENT.DELETE_SHIPMENTPACKAGING](ctx, payload) {
        payload.auth0UserId = authService.getUserId();
        const r = await yoyoHttp.delete('/api/ShipmentPackaging/DeleteShipmentPackaging', {
          headers: {
            'Content-Type': 'application/json'
          },
          data: payload
        });
        if (r.status === 200) {
            ctx.commit(MUTATIONS.CREATESHIPMENT.DELETE_SHIPMENTPACKAGING, payload);
        }
    },

    async reloadSavedAdressesOrDescription(ctx, r) {
        const flags = r.saveFlags;
        if (flags.saveReceiverAddress || flags.saveSenderAddress || flags.savePickupAddress) {
            yoyoHttp.clearCachedUrl('/api/AddressBook/GetAddressBook', {
                params: {
                    companyId: ctx.state.selectedCompanyId
                }
            });
            await ctx.dispatch(ACTIONS.CREATESHIPMENT.FETCH_ADDRESS_BOOK);
        }
        if (flags.saveDescription) {
            yoyoHttp.clearCachedUrl('/api/StaticData/GetCustomerDescriptions', {
                params: {
                    companyId: ctx.rootState.createShipment.selectedCompanyId
                }
            });
            await ctx.dispatch(ACTIONS.CREATESHIPMENT.FETCH_CUSTOMER_DESCRIPTIONS);
        }
    },

    async [ACTIONS.CREATESHIPMENT.FETCH_POSTAL_CODES](ctx, request) {
        const r = await yoyoHttp.get('/api/PostalCodes/GetPostalCodes', { params: request });
        return r.data;
    },

    async [ACTIONS.CREATESHIPMENT.FETCH_SHIPMENT_PROTOTYPE](ctx) {
        const r = await yoyoHttp.cachedGet('api/Shipment/GetShipmentPrototype', null);
        if (r.status === 200) {
            r.data.shipmentOptions = { notStackablePallet: false, isDocument: false, incoterms: 'DAP', exportReason: 'Permanent' };
            r.data.saveFlags = {
                saveDescription: false,
                saveReceiverAddress: false,
                saveSenderAddress: false,
                savePickupAddress: false
            };
            let currencyCode = r.data.customsAmount.currencyCode;
            r.data.shipmentAmount = {amount:0, currencyCode: currencyCode};
            r.data.insuranceAmount.termsAccepted = false;
            ctx.commit(MUTATIONS.CREATESHIPMENT.SET_PROTOTYPE_SHIPMENT, r.data);
        }
    },

    async [ACTIONS.CREATESHIPMENT.SET_PROTOTYPE](ctx, payload) {
        ctx.commit(MUTATIONS.CREATESHIPMENT.SET_PROTOTYPE_SHIPMENT, payload);
    },

    async [ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS](ctx) {
        ctx.commit(MUTATIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS);
    },

    [ACTIONS.CREATESHIPMENT.SELECT_SHIPPING_OPTION_PRODUCT](ctx, payload) {
        ctx.commit(MUTATIONS.CREATESHIPMENT.SELECT_SHIPPING_OPTION_PRODUCT, payload);
    },
    [ACTIONS.CREATESHIPMENT.CLEAR_SELECT_SHIPPING_OPTION_PRODUCT](ctx, salesProductId) {
        ctx.commit(MUTATIONS.CREATESHIPMENT.CLEAR_SELECT_SHIPPING_OPTION_PRODUCT, salesProductId);
    },
    [ACTIONS.CREATESHIPMENT.SET_INSURANCEAMOUNT_REQUIRED](ctx, data) {
        ctx.commit(MUTATIONS.CREATESHIPMENT.SET_INSURANCEAMOUNT_REQUIRED, data);
    },

    async [ACTIONS.CREATESHIPMENT.CHANGE_ISRECEIVERPAYS](ctx, data) {
        ctx.commit(MUTATIONS.CREATESHIPMENT.CHANGE_ISRECEIVERPAYS, data);
    },
    async [ACTIONS.CREATESHIPMENT.REQUEST_QUOTE](ctx, data) {
        data.shipment = ctx.getters.shipmentForBackend;

        const r = await yoyoHttp.post('/api/Shipment/CreateQuote', data);
    }
};

export default actions;
